/**
 * Checks if object `obj` has a property `key` and its value is not undefined.
 */
export const hasDef = <T, K extends keyof any>(
  obj: T,
  key: K,
): obj is T & {
  [k in K]: Required<Extract<T, { readonly [k in K]?: unknown }>>[K];
} => typeof obj === 'object' && key in <any>obj && (<any>obj)[key] !== undefined;
